import "./shops-selector.scss";
import { ChangeEvent, useCallback, useEffect, useMemo } from "react";
import debounce from "lodash.debounce";
import ShopsSelectorStore from "./shops-selector-store";
import ShopSelectorInput from "./select-dropdown/select-dropdown";
import ProcessingIndicator from "./processing-indicator/processing-indicator";
import { IShopTag, IShop } from "../../models/User";
import SelectedShop from "./selected-shop/selected-shop";
import { observer } from "mobx-react";
import FontBody1 from "../fonts/font-body1/font-body1";

interface IShopsSelectorProps {
    value?: IShop[],
    onChange: (list: IShop[]) => void;
    getShopTag?: (shop: IShop) => IShopTag;
    disabled?: boolean;
    includeSecondaryPortals?: boolean;
}

const ShopsSelector: React.FC<IShopsSelectorProps> = observer(({ onChange, getShopTag, disabled, value, includeSecondaryPortals = false }) => {
    const store = useMemo<ShopsSelectorStore>(() => new ShopsSelectorStore(onChange, getShopTag, includeSecondaryPortals), [onChange, getShopTag]);

    useEffect(() => {
        if (value) {
            store.setSelected(value);
        }
    }, [store, value]);

    const debouncedSearch = useMemo(
        () => store && debounce(store.searchShops, 500),
        [store]
    );

    const onSearchChange = useCallback((e: ChangeEvent) => {
        store.setSearchKey((e.target as HTMLInputElement).value);
        debouncedSearch();
    }, [debouncedSearch, store]);

    return (
        <div className="shops-multiselect">
            <ProcessingIndicator store={store} />
            <div className="select-aria">
                {store.selectedShops.map(shop => (
                    <SelectedShop onUnselect={store.unselect} shop={shop} key={shop.id} />
                ))}
                <div className="shops-select-container">
                    <FontBody1>
                        <input
                            value={store.searchKey}
                            onChange={onSearchChange}
                            disabled={disabled}
                        />
                    </FontBody1>
                    {
                        <ShopSelectorInput
                            store={store}
                        />
                    }
                </div>
            </div>
        </div>
    );
});

export default ShopsSelector;
